import { z } from 'zod';

const booleanStringEnum = z.enum(['true', 'false']);

export const ExamRoomPreviewSettingsFormSchema = z.object({
  withTimer: booleanStringEnum,
  shouldSortByExamSettings: booleanStringEnum,
  shouldDisplayAnswer: booleanStringEnum,
});

export type ExamRoomPreviewSettingsFormInput = z.infer<typeof ExamRoomPreviewSettingsFormSchema>;
